/**
 * UX mirror of functions/catalog/accessControl.js.
 * Backend CATALOG_SYNC_ALLOWED_USER_IDS remains the source of truth.
 */
export const CATALOG_SYNC_ALLOWED_USER_IDS = [
  'kIAz8XBuTQdRoOFHfKFcgTNeE6O2', // Дмитро
  '26cky9lbSieNNuHaKJqGTvnNeY83', // Іванка
  '1uBaPmet8DQUlylFHTRnW35ypPQ2', // Галя
]

export const isCatalogSyncAllowedUser = (uid) =>
  Boolean(uid && CATALOG_SYNC_ALLOWED_USER_IDS.includes(uid))
